'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


/*****************
 ** WEBPACK FOOTER
 ** ../~/history/lib/ExecutionEnvironment.js
 ** module id = 236
 ** module chunks = 3
 **/